import type { Rect } from '../hex/types';
import type { Viewport } from '../hex/camera2d';

export const MODAL_LAYOUT = {
    maxWidth: 420,
    maxHeight: 520,
    widthRatio: 0.42,
    heightRatio: 0.8,
    headerHeight: 44,
    sidePadding: 16,
    headerPaddingTop: 12,
    contentBottomPad: 12,
    closeSize: 18,
    closePad: 10,
    mobileBreakpoint: 720,
};

export function getModalSize(viewport: Viewport) {
    if (isMobileViewport(viewport)) {
        return { w: viewport.width, h: viewport.height };
    }
    return {
        w: Math.min(MODAL_LAYOUT.maxWidth, viewport.width * MODAL_LAYOUT.widthRatio),
        h: Math.min(MODAL_LAYOUT.maxHeight, viewport.height * MODAL_LAYOUT.heightRatio),
    };
}

export function isMobileViewport(viewport: Viewport): boolean {
    return viewport.width <= MODAL_LAYOUT.mobileBreakpoint;
}

export function getCloseRect(rect: Rect): Rect {
    return {
        x: rect.x + rect.w - MODAL_LAYOUT.closeSize - MODAL_LAYOUT.closePad,
        y: rect.y + MODAL_LAYOUT.closePad,
        w: MODAL_LAYOUT.closeSize,
        h: MODAL_LAYOUT.closeSize,
    };
}

export function getHeaderRect(rect: Rect): Rect {
    return {
        x: rect.x,
        y: rect.y,
        w: rect.w,
        h: MODAL_LAYOUT.headerHeight,
    };
}

export function getContentRect(rect: Rect): Rect {
    return {
        x: rect.x + MODAL_LAYOUT.sidePadding,
        y: rect.y + MODAL_LAYOUT.headerHeight,
        w: rect.w - MODAL_LAYOUT.sidePadding * 2,
        h: rect.h - MODAL_LAYOUT.headerHeight - MODAL_LAYOUT.contentBottomPad,
    };
}

export function clampRectToViewport(rect: Rect, viewport: Viewport): Rect {
    if (isMobileViewport(viewport)) {
        return { x: 0, y: 0, w: rect.w, h: rect.h };
    }
    const maxX = Math.max(0, viewport.width - rect.w);
    const maxY = Math.max(0, viewport.height - rect.h);
    return {
        x: Math.max(0, Math.min(maxX, rect.x)),
        y: Math.max(0, Math.min(maxY, rect.y)),
        w: rect.w,
        h: rect.h,
    };
}
